import { CoreContextProvider } from "PFApp/core_context_provider";
import { ErrorBoundary } from "PFComponents/error_boundary";

import { AppShellLayout } from "../app_shell_layout";
import { SuspenseWrapper } from "../components/suspense_wrapper";
import { MainRouter } from "../main_router";
import { ThemeContextProvider } from "../theme_context_provider";
import { useBootstrapper } from "../use_bootstrapper";
import { CurrentAccountErrorBoundary } from "./current_account_error_boundary";
import { MsTeamsInitializer } from "./ms_teams_initializer";
import { SignedInBootstrapper } from "./signed_in_bootstrapper";

const AppShell = () => {
  const { initialized } = useBootstrapper();

  if (!initialized) {
    return;
  }

  return (
    <ErrorBoundary>
      <AppShellLayout>
        <SignedInBootstrapper />
        <SuspenseWrapper>
          <MainRouter />
        </SuspenseWrapper>
      </AppShellLayout>
    </ErrorBoundary>
  );
};

export const Bootstrapper = () => (
  <CurrentAccountErrorBoundary>
    {/* ms teams initializer should be called before any useCurrentAccount hook */}
    <MsTeamsInitializer>
      <SuspenseWrapper>
        <ThemeContextProvider>
          <CoreContextProvider>
            <AppShell />
          </CoreContextProvider>
        </ThemeContextProvider>
      </SuspenseWrapper>
    </MsTeamsInitializer>
  </CurrentAccountErrorBoundary>
);
